import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_types_of_leave_is_the_fac_failing_to_pro'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_types_of_leave_is_the_fac_failing_to_pro',
  name: 'Which of the following types of leave is the facility failing to provide workers time off for, as legally required?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'ALL_PUBLIC_HOLIDAYS',
      text: 'All public holidays',
      externalIds: [
        {
          id: 'wb-wag-70',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ANNUAL_LEAVE',
      text: 'Annual leave',
      externalIds: [
        {
          id: 'wb-wag-71',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SICK_LEAVE',
      text: 'Sick leave',
      externalIds: [
        {
          id: 'wb-wag-72',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MATERNITY_LEAVE',
      text: 'Maternity leave',
      externalIds: [
        {
          id: 'wb-wag-73',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PATERNITY_LEAVE',
      text: 'Paternity leave',
      externalIds: [
        {
          id: 'wb-wag-74',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PERSONAL_LEAVE',
      text: 'Personal leave',
      externalIds: [
        {
          id: 'wb-wag-75',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'VIETNAM_PROVIDE_30_MINUTES_OF_TIME_OFF_PER_DAY_FOR_FEMALE_WORKE',
      text: 'Vietnam: Provide 30 minutes of time off per day for female workers for rest during their period',
      externalIds: [
        {
          id: 'wb-wag-121x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ETHIOPIA_PROVIDE_LEGALLY_REQUIRED_TIME_OFF_FOR_PRENATAL_VISITS',
      text: 'Ethiopia: Provide legally required time off for prenatal visits',
      externalIds: [
        {
          id: 'wb-wag-122x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ETHIOPIA_PROVIDE_TIME_OFF_FOR_WORKERS_TO_APPEAR_AT_LABOR_DISPUT',
      text: 'Ethiopia: Provide time off for workers to appear at labor dispute hearings and to exercise their civil rights and duties',
      externalIds: [
        {
          id: 'wb-wag-123x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER_TYPES_OF_REQUIRED_LEAVE',
      text: 'Other types of required leave',
      externalIds: [
        {
          id: 'wb-wag-76',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe the TYPE of required leave that is not provided:',
        externalIds: [
          {
            id: 'wb-wag-77f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'ALL_PUBLIC_HOLIDAYS',
                'ANNUAL_LEAVE',
                'SICK_LEAVE',
                'MATERNITY_LEAVE',
                'PATERNITY_LEAVE',
                'PERSONAL_LEAVE',
                'VIETNAM_PROVIDE_30_MINUTES_OF_TIME_OFF_PER_DAY_FOR_FEMALE_WORKE',
                'ETHIOPIA_PROVIDE_LEGALLY_REQUIRED_TIME_OFF_FOR_PRENATAL_VISITS',
                'ETHIOPIA_PROVIDE_TIME_OFF_FOR_WORKERS_TO_APPEAR_AT_LABOR_DISPUT',
                'OTHER_TYPES_OF_REQUIRED_LEAVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
  },
  externalIds: [
    {
      id: 'wb-wag-69',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 6850,
  sectionId: '2.2.12',
  impactArea: 'Working Hours',
  impactAreaId: 'WORKING_HOURS_AND_OVERTIME',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
